// #region Imports

import Vue from 'vue';
import {
  MdAutocomplete,
  MdButton,
  MdCheckbox,
  MdChips,
  MdField,
  MdHighlightText,
  MdList,
  MdMenu,
  MdRadio,
  MdSwitch,
} from 'vue-material/dist/components';

import vClickOutside from 'v-click-outside';
import VueLocalforage from 'v-localforage';

// #endregion

// #region Component Registration

Vue.use(MdAutocomplete);
Vue.use(MdButton);
Vue.use(MdCheckbox);
Vue.use(MdChips);
Vue.use(MdField);
Vue.use(MdHighlightText);
Vue.use(MdList);
Vue.use(MdMenu);
Vue.use(MdRadio);
Vue.use(MdSwitch);

Vue.use(vClickOutside);
Vue.use(VueLocalforage);

// #endregion
